import { Helmet } from "react-helmet-async";

const BrahmacharyaSEO = () => {
  return (
    <Helmet>
      <title>Brahmacharya in Ayurveda | Discipline, Mental Strength & Wellness</title>

      <meta
        name="description"
        content="Learn the true meaning of Brahmacharya in Ayurveda. Discover its benefits for mental strength, self-discipline, energy balance, and a healthy lifestyle in modern life."
      />

      <meta
        name="keywords"
        content="Brahmacharya, Brahmacharya meaning, Brahmacharya in Ayurveda, benefits of Brahmacharya, Brahmacharya lifestyle, Brahmacharya for mental strength, Brahmacharya and wellness, Ayurvedic lifestyle discipline"
      />

      <link rel="canonical" href="https://arvindmerasathi.com/brahmacharya-ayurveda" />
    </Helmet>
  );
};

export default BrahmacharyaSEO;
